class EventAggregator {
  events = {};

  // #### registra
  // Registra un evento ( passato come stringa o costruttore) specificando
  // la callback da invocare ad ogni sua emissione ed un opzionale
  // contesto di esecuzione per la callback
  subscribe = (event, callback, ctx) => {
    const eventName = this.getEventName(event);
    if (this.events[eventName] === undefined) {
      this.events[eventName] = [];
    }

    this.events[eventName] = this.events[eventName].concat([{ callback, context: ctx }]);

    return this;
  };

  // #### disdici
  // Disdici la registrazione ad un evento di una callback in
  // modo tale che successive emissioni dell'evento non
  // ne causino l'invocazione
  unsubscribe = (event, callback, ctx) => {
    const eventName = this.getEventName(event);

    let i = 0;
    for (i = 0; i < this.events[eventName].length; i += 1) {
      if (this.events[eventName][i].callback === callback) {
        this.events[eventName].splice(i, 1);
        return this;
      }
    }

    return this;
  };

  // #### pubblica
  // Pubblica un evento sull'aggregatore eventi e scatena
  // tutte le funzioni che si sono registrate per l'evento
  // passato come parametro
  pubblica = (event, ...args) => {
    const eventName = this.getEventName(event);
    let params = args;

    if (event !== eventName) {
      params = Array.prototype.slice.apply(params);
      params.unshift(eventName);
    }

    let i = 0;
    if (this.events[eventName] !== undefined) {
      for (i = 0; i < this.events[eventName].length; i += 1) {
        this.events[eventName][i].callback
          .call(this.events[eventName][i].context || this, params[0]);
      }
    }

    return this;
  };

  // #### _nomeEvento
  // Helper utilizzato per recuperare il nome di un evento analizzandolo
  // eslint-disable-next-line class-methods-use-this
  getEventName = (event) => {
    if (typeof (event) === 'string') {
      return event;
    }
    if (typeof (event) === 'function') {
      return event.name;
    }
    return event.constructor.name;
  };
}

export default EventAggregator;
